import React from 'react';
import {t} from 'shared/core';
import {endpoints, types} from 'main/tools';
import {InteractiveTable, DropdownFilter, Tag} from 'components';
import {SurveyEmployeeStatus} from 'stores/surveys';
import {observer} from 'mobx-react';
import EmployeeProfileContainer from '../../EmployeeProfileContainer';
import {FormattedMessage} from 'react-intl';

const Name = observer(({model}) => {
  return (
    <div className='flex align-items-middle'>
      {model.survey.name}
      {model.survey.anonymous && <Tag colour='waterloo' className='ml1'>
        <FormattedMessage id='surveys.view.Anonymous'/>
      </Tag>}
    </div>
  );
});

const COLUMNS = [
  {
    header: 'employees.profile.surveys.Survey Name',
    width: 6,
    component: Name
  },
  {
    header: 'employees.profile.surveys.Due Date',
    width: 3,
    attribute: 'dueDateView'
  },
  {
    header: 'employees.profile.surveys.Completed Date',
    width: 3,
    attribute: 'submittedAtView'
  }
];

const LOCALIZATION = {
  emptyState: 'employees.profile.surveys.No surveys to display'
};

function statusFilters() {
  return [
    {
      id: 'active',
      display: t('employees.profile.surveys.Active Surveys')
    },
    {
      id: 'closed',
      display: t('employees.profile.surveys.Closed Surveys')
    }
  ];
}

const SurveysContainer = observer(({uiState}) => {
  const {employee} = uiState;

  return (
    <EmployeeProfileContainer uiState={uiState}>
      <InteractiveTable
        title={t('employees.profile.surveys.Surveys')}
        columns={COLUMNS}
        showLinks={false}
        saveStateToUrl={true}
        showPath={model => model.submitted && `/surveys/manage/survey/${model.survey.id}/response/${employee.id}`}
        proxy={{
          type: 'async',
          endpoint: endpoints.SURVEYS.EMPLOYEE_STATUSES.FOR_EMPLOYEE_PROFILE.with(employee.id),
          modelType: types.SURVEYS.EMPLOYEE_STATUS,
          model: SurveyEmployeeStatus
        }}
        localization={LOCALIZATION}
      >
        <DropdownFilter options={statusFilters()} attr='status'/>
      </InteractiveTable>
    </EmployeeProfileContainer>
  );
});

export default SurveysContainer;
